module.exports = __webpack_public_path__ + "static/media/number-four.9c656634.svg";